// Simple toast notification utility
export const toast = {
  success: (message: string) => {
    showToast(message, 'success');
  },
  error: (message: string) => {
    showToast(message, 'error');
  },
  info: (message: string) => {
    showToast(message, 'info');
  },
  warning: (message: string) => {
    showToast(message, 'warning');
  }
};

function showToast(message: string, type: 'success' | 'error' | 'info' | 'warning') {
  // Remove any existing toasts
  const existingToasts = document.querySelectorAll('.toast-notification');
  existingToasts.forEach(toast => toast.remove());

  // Create toast element
  const toast = document.createElement('div');
  toast.className = `toast-notification toast-${type}`;
  
  // Add icon based on type
  const icons = {
    success: '✓',
    error: '✗',
    info: 'ℹ',
    warning: '⚠'
  };
  
  toast.innerHTML = `
    <div class="toast-icon">${icons[type]}</div>
    <div class="toast-message">${message}</div>
  `;
  
  document.body.appendChild(toast);
  
  // Trigger animation
  setTimeout(() => toast.classList.add('show'), 10);
  
  // Auto-remove after 4 seconds
  setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => toast.remove(), 300);
  }, 4000);
}

// Add CSS styles dynamically
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = `
    .toast-notification {
      position: fixed;
      top: 20px;
      right: 20px;
      min-width: 300px;
      max-width: 500px;
      background: white;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      display: flex;
      align-items: center;
      padding: 16px;
      gap: 12px;
      z-index: 10000;
      opacity: 0;
      transform: translateX(400px);
      transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    }
    
    .toast-notification.show {
      opacity: 1;
      transform: translateX(0);
    }
    
    .toast-icon {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      font-weight: bold;
      flex-shrink: 0;
    }
    
    .toast-success .toast-icon {
      background: #10b981;
      color: white;
    }
    
    .toast-error .toast-icon {
      background: #ef4444;
      color: white;
    }
    
    .toast-info .toast-icon {
      background: #3b82f6;
      color: white;
    }
    
    .toast-warning .toast-icon {
      background: #f59e0b;
      color: white;
    }
    
    .toast-message {
      flex: 1;
      font-size: 14px;
      color: #1f2937;
      line-height: 1.5;
    }
    
    .toast-success {
      border-left: 4px solid #10b981;
    }
    
    .toast-error {
      border-left: 4px solid #ef4444;
    }
    
    .toast-info {
      border-left: 4px solid #3b82f6;
    }
    
    .toast-warning {
      border-left: 4px solid #f59e0b;
    }
  `;
  document.head.appendChild(style);
}
